import * as React from 'react';
import Slider, { Settings } from 'react-slick';

import { SliderWrapper } from './components/styled';

export { Arrows } from './components';

export interface ISimpleSliderProps {
  conf: Settings;
  sliderRef?: React.LegacyRef<Slider>;
}

const SimpleSlider: React.FC<ISimpleSliderProps> = ({
  conf,
  children,
  sliderRef,
}) => (
  <SliderWrapper>
    <Slider ref={sliderRef} {...conf}>
      {children}
    </Slider>
  </SliderWrapper>
);

export default SimpleSlider;
